import { createContext, useContext } from "react";

export interface FilteredItem {
  id: string;
  label: string;
}

export interface IItemNavigatorProps {
  currentId: string | undefined;
  buildPath: (id: string) => string;
}

const FilteredItemIdsContext = createContext<string>("");

export const FilteredItemIdsProvider = FilteredItemIdsContext.Provider;

/** Returns the current navKey from context */
export const useNavKey = () => useContext(FilteredItemIdsContext);

// Lightweight store to avoid serializing navItems into location.state
let _navItems: FilteredItem[] = [];
let _navKey = "";

export const navStore = {
  set(items: FilteredItem[]): string {
    _navItems = items;
    _navKey = Date.now().toString(36);
    return _navKey;
  },
  get(key: string): FilteredItem[] | null {
    return key === _navKey ? _navItems : null;
  },
};
